import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { isConnected } from "../api/api";
import { CustomLayout } from "../components";
import { getAllProjectsByEnterprise } from "../redux/VRL/thunks";
import { getAllResponsesTrainingFormProject, updateApiDBwhenIsConected } from "../redux/VRT/thunks";
import TrainingMenu from "../pages/VrTraining/templates/TrainingMenu";

const LayoutVRTraining = () => {
    const { typeAdmin } = useSelector((state) => state.auth);
    const dispatch = useDispatch()
    console.log("uset type:", typeAdmin)

    useEffect(() => {
        const getApiInfo = async () => {
            if (isConnected) {
                const proyects = await dispatch(getAllProjectsByEnterprise())
                if (proyects) {
                    await dispatch(getAllResponsesTrainingFormProject(proyects[0]._id))
                    if (!navigator.onLine) {
                        dispatch(updateApiDBwhenIsConected())
                    }
                }
            }
            else {
                dispatch(getAllResponsesTrainingFormProject(1))
            }
        }
        getApiInfo()
    }, [dispatch])

    if (typeAdmin === 'VRT') {
        return (
            <CustomLayout>
                <TrainingMenu />
                <Outlet />
            </CustomLayout>
        )
    }
    else {
        return <Navigate to={"/auth/"}> </Navigate>
    }
    // return typeAdmin === 'VRL' ? : 
    // return (
    //     <CustomLayout>
    //         <TrainingMenu />
    //         <Outlet />
    //     </CustomLayout>
    // );
};

export default LayoutVRTraining;
